<template>
  <div>
    <Paragraph
      :paragraph="context.p1"
      p-item-distance
      p-distance
    />
    <Paragraph
      :paragraph="context.p2"
      p-distance
    />
    <Paragraph
      :paragraph="context.p3"
      p-distance
    />
    <Paragraph
      :paragraph="context.p4"
    />
  </div>
</template>

<script>
import Paragraph from '@/components/Paragraph';

export default {
  name: 'ParagraphGroup',
  components: { Paragraph },
  props: {
    context: {
      type: Object,
      default: null,
    },
    pDistance: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
